module.exports = __webpack_public_path__ + "img/40_80.eee38c63.png";